import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Hero from '../components/Hero';
import ProductsHighlight from '../components/ProductsHighlight';
import WhyChooseUs from '../components/WhyChooseUs';
import IndustriesWeServe from '../components/IndustriesWeServe';
import AboutPreview from '../components/AboutPreview';
import ContactCTA from '../components/ContactCTA';

const Landing = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out-cubic',
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <div className="overflow-x-hidden">
      <Hero />
      <ProductsHighlight />
      <AboutPreview />
      <WhyChooseUs />
      <IndustriesWeServe />
      <ContactCTA />
    </div>
  );
};

export default Landing;